import type { LocaleMessageBundle } from '../../types'
import { orderWebViewMessages } from './order-webview'

export const publicMessages: LocaleMessageBundle = {
  vi: {
    ...orderWebViewMessages.vi,
  },
  en: {
    ...orderWebViewMessages.en,
  },
}
